// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";
import StablePrime from "../../../components/Tables/StablePrime";
const columns = [
  {
    title: "Station",
    dataIndex: "_id",
    key: "_id",
  },
  {
    title: "Process",
    dataIndex: "Process",
    key: "Process",
  },
  {
    title: "Document #",
    dataIndex: "Document #",
    key: "Link",
    render: (text, record) => (
      <a
        href={record.Link}
        target="_blank"
        rel="noopener noreferrer"
        className="gx-link"
      >
        {text}
      </a>
    ),
  },
];

const SOP = ({ selectedLid }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [loginError, setLoginError] = useState(false);



  return (
    <>
      <SessionError visible={loginError} />
      <div style={{ padding: "10px" }}>
        <StablePrime url="/linedash/tabs/sop" data={{ lid: selectedLid }} />
        {/* <Table
          className="gx-table-responsive TableBlack"
          columns={columns}
          dataSource={data}
        /> */}
      </div>
    </>
  )
   
};

export default SOP;
